export default "/images/reliqideus-front.jpeg?966b8eb546743841f8c1611cea46d067";